var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "#fff",
    stroke: "#fff",
    viewBox: "0 0 495.003 495.003"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.711 456.687a8.01 8.01 0 0 0 4.266 7.072 7.99 7.99 0 0 0 8.245-.468l55.09-37.616-67.6-32.22v63.232zm327.72-424.244a8.02 8.02 0 0 0-5.44-2.125 7.9 7.9 0 0 0-3.5.816L7.905 264.422a14.154 14.154 0 0 0 .153 25.472L133.4 349.618l250.62-205.99-219.565 220.786 156.145 74.4a14.1 14.1 0 0 0 6.084 1.376c1.768 0 3.519-.322 5.186-.977a14.19 14.19 0 0 0 7.97-7.956l154.596-390a7.97 7.97 0 0 0-2.005-8.814z"
  })));
};
export default SvgSend;